import { useCallback } from 'react';
import { formatDistanceToNow as dateFnsFormatDistanceToNow } from 'date-fns';
import { useDateLocale } from '@/hooks/useDateLocale';

/**
 * Returns a locale-aware formatDistanceToNow function (e.g. "5 minutes ago" / "5 dakika önce").
 */
export function useFormatDistanceToNow() {
  const locale = useDateLocale();
  return useCallback(
    (date: Date) => dateFnsFormatDistanceToNow(date, { locale }),
    [locale]
  );
}
